import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { WorkItem } from '../../models/workItem';
import propertyService from '../../services/propertyService';
import { WorkItemEstimate } from '../../models/workItem';
import WorkItemList from '../WorkItemComponents/WorkItemList';
import AddWorkItemModal from '../WorkItemComponents/AddWorkItemModal';

interface PropertyWorkItemsDisplayProps {
  workItems: WorkItem[];
  propertyId: string;
  onAddWorkItem: (newWorkItem: WorkItem) => void;
  propertyValue: number;
  address: string;
}

const PropertyWorkItemsDisplay: React.FC<PropertyWorkItemsDisplayProps> = ({
  workItems,
  propertyId,
  onAddWorkItem,
  propertyValue,
  address
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [analysisResults, setAnalysisResults] = useState<{
    [workItemId: string]: WorkItemEstimate;
  }>({});

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleAnalyzeWorkItem = async (workItemId: string) => {
    try {
      const analysis: WorkItemEstimate = await propertyService.analyzeWorkItem(
        propertyId,
        workItemId
      );
      setAnalysisResults((prev) => ({
        ...prev,
        [workItemId]: analysis,
      }));
    } catch (error) {
      console.error(`Error analyzing work item ${workItemId}:`, error);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Work Items
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenModal}
        sx={{ mb: 2 }}
      >
        Add Work Item
      </Button>
      <WorkItemList
        workItems={workItems}
        analysisResults={analysisResults}
        onAnalyzeWorkItem={handleAnalyzeWorkItem}
        propertyId={propertyId}
        address={address}
      />
      <AddWorkItemModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onSave={onAddWorkItem}
      />
    </Box>
  );
};

export default PropertyWorkItemsDisplay;
